import { useEffect, useState } from "react";
import { Container, Button, Form, Alert, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../reducers";
import {
  fetchClient,
  checkoutCart,
  fetchShippingCost,
  resetShippingCost,
  extendCartSession,
} from "../actions/cartActions";
import { CheckoutData, FetchClientData } from "../actions/types";
import ModalAlert from "./ModalAlert";

const ZIP_CODE_RESTRICTED = [{ city: "Piamonte", zipCode: "2529" }];
const CELL_PHONE_USERS_ALLOWED = [
  { name: "Carolina Ñañez", cellPhone: "3401646138" },
];

const INITIAL_MODAL_ALERT = {
  show: false,
  message: [] as string[],
  onSuccess: () => {},
  onClose: () => {},
};
const Checkout = () => {
  const isLoadingCart = useSelector((state: RootState) => state.cart.isLoading);
  const client = useSelector((state: RootState) => state.cart.client);
  const cart = useSelector((state: RootState) => state.cart.cart);
  const subTotalCart = useSelector((state: RootState) => +state.cart.totalCart);
  const provinces = useSelector((state: RootState) => state.cart.provinces);
  const shippingCostState = useSelector(
    (state: RootState) => state.cart.shippingCost
  );
  const incrementSale = useSelector(
    (state: RootState) => state.cart.incrementSale
  );
  const addressPickup = useSelector(
    (state: RootState) => state.cart.addressPickup
  );
  const dispatch: any = useDispatch();
  const navigate: any = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showPersonalInfo, setShowPersonalInfo] = useState(true);
  const [showSendInfo, setShowSendInfo] = useState(false);
  const [showPayInfo, setShowPayInfo] = useState(false);
  const [modalAlert, setModalAlert] = useState(INITIAL_MODAL_ALERT);
  const [totalCart, setTotalCart] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const [textButton, setTextButton] = useState("Confirmar compra");
  const [failedSubmit, setFailedSubmit] = useState(0);

  const [cell_phone, setCellPhone] = useState("");
  const [name, setName] = useState("");
  const [last_name, setLastName] = useState("");
  const [document_number, setDocumentNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postal_code, setPostalCode] = useState("");
  const [province, setProvince] = useState(0);
  const [local_pickup, setLocalPickup] = useState(0);
  const [payway_id, setPaywayId] = useState(0);
  const [increase1, setIncrease1] = useState(0);
  const [incrementAmount, setIncrementAmount] = useState(0);
  const [restrictedCityError, setRestrictedCityError] = useState("");

  const onFetchClient = (request: FetchClientData) => {
    dispatch(fetchClient(request));
  };
  const onCheckoutCart = (request: CheckoutData) => {
    dispatch(checkoutCart(request));
  };

  useEffect(() => {
    dispatch(extendCartSession());
  }, [dispatch]);

  const verifySession = () => {
    if (cart?.length === 0 && !isLoadingCart) {
      setModalAlert({
        ...modalAlert,
        show: true,
        message: [
          "Lo sentimos, no hemos podido completar la carga del carrito de compras.",
          "Esto puede deberse a un problema de conexión.",
          "Te pedimos que vuelvas a cargar los productos para poder finalizar la compra.",
        ],
        onSuccess: () => {
          setModalAlert(INITIAL_MODAL_ALERT);
          navigate("/");
        },
        onClose: () => {
          setModalAlert(INITIAL_MODAL_ALERT);
          navigate("/");
        },
      });
    }
  };

  useEffect(() => {
    if (client) {
      setName(client.name);
      setLastName(client.last_name);
      setDocumentNumber(client.document_number);
      setEmail(client.email);
      setAddress(client.address);
      setCity(client.city);
      setPostalCode(client.postal_code);
      setProvince(client.province);
    }
  }, [client]);

  const handleFetchClient = () => {
    if (cell_phone.length !== 10) {
      setModalAlert({
        ...modalAlert,
        show: true,
        message: ["WhatsApp incorrecto"],
        onSuccess: () => setModalAlert(INITIAL_MODAL_ALERT),
        onClose: () => setModalAlert(INITIAL_MODAL_ALERT),
      });
    } else {
      onFetchClient({ cell_phone, client_id: null });
      setTotalCart(subTotalCart);
    }
  };

  const handlePersonalInfo = () => {
    if (
      name?.length > 0 &&
      last_name?.length > 0 &&
      cell_phone?.length === 10 &&
      validateEmail() &&
      document_number?.length > 6
    ) {
      setShowPersonalInfo(false);
      setShowSendInfo(true);
      window.scrollTo(0, 0);
      verifySession();
    } else {
      setModalAlert({
        ...modalAlert,
        show: true,
        message: ["Complete correctamente los campos."],
        onSuccess: () => setModalAlert(INITIAL_MODAL_ALERT),
        onClose: () => setModalAlert(INITIAL_MODAL_ALERT),
      });
    }
  };

  function validateEmail() {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    setModalAlert({
      ...modalAlert,
      show: true,
      message: ["Ingresar un mail válido."],
      onSuccess: () => setModalAlert(INITIAL_MODAL_ALERT),
      onClose: () => setModalAlert(INITIAL_MODAL_ALERT),
    });
    return false;
  }

  const handleSendInfo = () => {
    if (
      local_pickup !== 0 &&
      address?.length > 0 &&
      city?.length > 0 &&
      postal_code?.length > 0 &&
      province !== 0
    ) {
      if (local_pickup === 5) {
        dispatch(fetchShippingCost(province));
      }
      setShowSendInfo(false);
      setShowPayInfo(true);
      window.scrollTo(0, 0);
    } else {
      setModalAlert({
        ...modalAlert,
        show: true,
        message: ["Todos los campos son requeridos."],
        onSuccess: () => setModalAlert(INITIAL_MODAL_ALERT),
        onClose: () => setModalAlert(INITIAL_MODAL_ALERT),
      });
    }
  };

  const handleChangePayWay = (payWayValue: number) => {
    setPaywayId(payWayValue);
    if (payWayValue === 5) {
      setIncrease1(incrementSale);
      setTextButton("Pagar");
    } else {
      setIncrease1(0);
      setTextButton("Confirmar compra");
    }
  };

  const handleBack = () => {
    resetTotalCart();
    if (showPayInfo) {
      setShowSendInfo(true);
      setShowPayInfo(false);
      window.scrollTo(0, 0);
    } else {
      setShowPersonalInfo(true);
      setShowSendInfo(false);
      window.scrollTo(0, 0);
    }
  };

  const resetTotalCart = () => {
    dispatch(resetShippingCost());
    setTotalCart(subTotalCart);
    setPaywayId(0);
    setShippingCost(0);
    setIncrementAmount(0);
    setIncrease1(0);
  };

  const onSetTotalCart = () => {
    let subTotal = subTotalCart;
    subTotal = subTotal + shippingCost;
    const increment = Math.round((subTotal * increase1) / 100);
    const total = subTotal + increment;
    setIncrementAmount(increment);
    setTotalCart(total);
  };

  useEffect(() => {
    if (local_pickup === 5) {
      setShippingCost(shippingCostState);
    } else {
      setShippingCost(0);
    }
  }, [shippingCostState, local_pickup]);

  useEffect(() => {
    onSetTotalCart();
    // eslint-disable-next-line
  }, [shippingCost, payway_id]);

  useEffect(() => {
    if (
      ZIP_CODE_RESTRICTED.some(
        (item) =>
          item.zipCode === postal_code ||
          item.city.toLocaleLowerCase() === city.toLocaleLowerCase()
      ) &&
      !CELL_PHONE_USERS_ALLOWED.some((item) => item.cellPhone === cell_phone)
    ) {
      setRestrictedCityError(
        "No podemos concretar la compra porque en esta ciudad tenemos un revendedor exclusivo"
      );
    } else {
      setRestrictedCityError("");
    }
  }, [city, postal_code, cell_phone]);

  const handleSubmit = () => {
    if (payway_id === 0) {
      setModalAlert({
        ...modalAlert,
        show: true,
        message: ["Todos los campos son requeridos."],
        onSuccess: () => setModalAlert(INITIAL_MODAL_ALERT),
        onClose: () => setModalAlert(INITIAL_MODAL_ALERT),
      });
    } else {
      if (totalCart > 0 && subTotalCart > 0) {
        setIsLoading(true);
        const user_id = 1;
        const client_id = client ? client.id : "";
        const post = "0002";
        const wholesale = 1;
        const invoice_type_id = 6;
        onCheckoutCart({
          user_id,
          post,
          wholesale,
          invoice_type_id,
          client_id,
          cell_phone,
          name,
          last_name,
          document_number,
          email,
          address,
          city,
          postal_code,
          province,
          local_pickup,
          payway_id,
          increase1,
          totalCart,
          subTotalCart,
          shippingCost,
        });
      } else {
        if (failedSubmit > 1) {
          setModalAlert({
            ...modalAlert,
            show: true,
            message: ["Ha ocurrido un error, vuelva a cargar sus datos."],
            onSuccess: () => setModalAlert(INITIAL_MODAL_ALERT),
            onClose: () => setModalAlert(INITIAL_MODAL_ALERT),
          });
        }
        setFailedSubmit(failedSubmit + 1);
      }
    }
  };
  return (
    <Container>
      {showPersonalInfo && (
        <div className="col-md-6">
          <h2>Datos Personales</h2>
          <Form.Group>
            <Form.Label>
              Ingresá tu número de WhatsApp (sin 15 y sin 0)
            </Form.Label>
            <Form.Control
              type="number"
              name="cellphone"
              id="cellphone"
              size="lg"
              placeholder="Ej. 3415654321"
              className="col-md-6 mb-2"
              defaultValue={cell_phone}
              onChange={(element) => setCellPhone(element.target.value)}
              onBlur={handleFetchClient}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              name="name"
              id="name"
              size="lg"
              className="col-md-6 mb-2"
              defaultValue={name}
              onChange={(element) => setName(element.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Apellido</Form.Label>
            <Form.Control
              name="last_name"
              id="last_name"
              size="lg"
              className="col-md-6 mb-2"
              defaultValue={last_name}
              onChange={(element) => setLastName(element.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              id="email"
              size="lg"
              className="col-md-6 mb-2"
              defaultValue={email}
              onChange={(element) => setEmail(element.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>DNI (sin puntos y sin espacios)</Form.Label>
            <Form.Control
              type="number"
              name="document_number"
              id="document_number"
              size="lg"
              className="col-md-6 mb-2"
              defaultValue={document_number}
              onChange={(element) => setDocumentNumber(element.target.value)}
            />
          </Form.Group>
          <p className="text-muted">*Todos los campos son requeridos</p>
          <Button
            variant="secondary btn-lg btn-block col-md-6"
            onClick={handlePersonalInfo}
          >
            Siguiente
          </Button>
        </div>
      )}
      {showSendInfo && (
        <div className="col-md-6">
          <h2>Envío o Retiro</h2>
          <Form.Group>
            <Form.Label>Formas de envío</Form.Label>
            <Form.Select
              name="local_pickup"
              id="local_pickup"
              size="lg"
              className="col-md-6 mb-2"
              defaultValue={local_pickup}
              onChange={(element: any) => setLocalPickup(+element.target.value)}
            >
              <option value="0">Seleccioná una opción</option>
              <option value="1">Cadete (Vivís en Rosario y alrededores)</option>
              <option value="2">
                Retirás en el local (España 1025 - Rosario)
              </option>
              <option value="3">
                Correo argentino (Retirás en correo más cercano)
              </option>
              {/* <option value="4">
                Via Cargo (Retirás en sucursal más cercana)
              </option>
              <option value="5">
                Shipnow (Envío a domicilio)
              </option> */}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>Direccion</Form.Label>
            <Form.Control
              name="address"
              id="address"
              size="lg"
              className="col-md-6 mb-2"
              defaultValue={address}
              onChange={(element) => setAddress(element.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Localidad</Form.Label>
            <Form.Control
              name="city"
              id="city"
              size="lg"
              className="col-md-6 mb-2"
              defaultValue={city}
              onChange={(element) => setCity(element.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Codigo Postal</Form.Label>
            <Form.Control
              name="postal_code"
              id="postal_code"
              size="lg"
              className="col-md-6 mb-2"
              defaultValue={postal_code}
              onChange={(element) => setPostalCode(element.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Provincia</Form.Label>
            <Form.Select
              name="province"
              id="province"
              size="lg"
              className="col-md-6 mb-2"
              value={province}
              onChange={(element: any) => setProvince(+element.target.value)}
            >
              <option value="0">Seleccioná una provincia</option>
              {provinces.map((province: any, index: number) => {
                return (
                  <option key={index} value={province.id}>
                    {province.name}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
          <p className="text-muted">*Todos los campos son requeridos</p>
          {!!restrictedCityError && (
            <Alert variant="warning">
              <Alert.Heading>Lo sentimos</Alert.Heading>
              <p>{restrictedCityError}</p>
            </Alert>
          )}
          <div className="form-group col-md-6 mt-4 mb-2">
            <Button variant="light btn-lg me-1" onClick={handleBack}>
              Volver
            </Button>
            {!restrictedCityError && (
              <Button
                disabled={!!restrictedCityError}
                variant="secondary btn-lg w-50"
                onClick={handleSendInfo}
              >
                Siguiente
              </Button>
            )}
          </div>
        </div>
      )}
      {showPayInfo && (
        <div className="col-md-6">
          <h2>Forma de pago</h2>
          <Form.Group>
            <Form.Label>Formas de pago</Form.Label>
            <Form.Select
              name="payway_id"
              id="payway_id"
              size="lg"
              className="mb-3"
              defaultValue={payway_id}
              onChange={(element: any) =>
                handleChangePayWay(+element.target.value)
              }
            >
              <option value="0">Seleccioná una opción</option>
              <option value="1">
                Contado (Sólo si retirás en el local o recibís con cadete)
              </option>
              <option value="3">
                Depósito / Transferencia bancaria (Enviamos cuenta a tu email)
              </option>
              <option value="5">
                Tarjetas Crédito Débito - Rapipago - PagoFacil
              </option>
            </Form.Select>
          </Form.Group>
          {local_pickup === 2 && (
            <Alert variant="success">
              <Alert.Heading>Sucursal Newton: </Alert.Heading>
              <p>{addressPickup}</p>
            </Alert>
          )}
          {payway_id === 5 && (
            <Alert variant="info" id="alert-increment" className="fs-5">
              El pago tiene un incremento del {increase1}% por el costo del
              prestador de servicio
            </Alert>
          )}
          {(shippingCost > 0 || increase1 > 0) && (
            <Row className="fs-5">
              <Col className="col-8">Subtotal:</Col>
              <Col className="text-end col-4">${subTotalCart * 1}</Col>
            </Row>
          )}
          {shippingCost > 0 && (
            <Row className="fs-5">
              <Col className="col-8">Envío:</Col>
              <Col className="text-end col-4">${shippingCost}</Col>
            </Row>
          )}
          {increase1 > 0 && (
            <Row className="fs-5">
              <Col className="col-8">Costo forma de pago:</Col>
              <Col className="text-end col-4">${incrementAmount}</Col>
            </Row>
          )}
          <hr />
          <Row className="fs-3 mb-3">
            <Col className="col-8">
              <b>Total:</b>
            </Col>
            <Col className="text-end col-4">
              <b>${totalCart}</b>
            </Col>
          </Row>
          <Row>
            <Col className="text-end">
              <Button variant="light btn-lg me-1 mb-2" onClick={handleBack}>
                Volver
              </Button>
              <Button
                variant="success btn-lg me-1 mb-2"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Procesando..." : textButton}
              </Button>
            </Col>
          </Row>
        </div>
      )}
      <ModalAlert
        show={modalAlert.show}
        onClose={modalAlert.onClose}
        message={modalAlert.message}
        onSuccess={modalAlert.onSuccess}
      />
    </Container>
  );
};

export default Checkout;
